import { useTranslation } from "react-i18next";
import ContainerMd from "../../../components/Layouts/ContainerMd";
import LogoWithLanguage from "../../../components/logo-with-language/LogoWithLanguage";
import ProgramCard from "../../../components/program-card/ProgramCard";
import QuranImage from "../../../assets/img/book-Image.png";
import QuranImageTwo from "../../../assets/img/book-Image-2.png";
import { useNavigate } from "react-router-dom";

export default function ChooseProgram() {
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.chooseProgram",
  });
  const navigater = useNavigate();
  return (
    <ContainerMd className={"flex-1 flex flex-col"}>
      <div className="w-full pb-2 border-b border-gray-200">
        <LogoWithLanguage />
        <div className="w-full">
          <h2 className="mt-6 text-3xl font-bold text-gray-700">
            {t("title")}
          </h2>
          <p className="w-full mt-2 text-lg leading-6 text-gray-500">
            {t("subtitle")}
          </p>
        </div>
      </div>
      <div className="mt-8 w-full grid grid-cols-1 sm:grid-cols-2 gap-6">
        <ProgramCard
          title={t("program1.title")}
          description={t("program1.description")}
          coverImage={QuranImage}
          onClick={() => navigater("/candidate/payment-subscriptions")}
          isAvailable
        />
        <ProgramCard
          title={t("program2.title")}
          description={t("program2.description")}
          coverImage={QuranImageTwo}
          onClick={() => {}}
        />
      </div>
    </ContainerMd>
  );
}
